<template>
  <v-sheet
    fill-height
    align="center"
  >
    <v-card
      color="tertiary"
      class="ma-2"
      :class="mobile ? 'mobilewindow' : 'mainwindow'"
    >
      <template #prepend>
        <div class="text-h3 text-primary pa-1">
          Songbook PDFs
          <v-btn to="/listing">
            Albums
          </v-btn>
        </div>
      </template>
      <v-card-title>
        <div class="d-flex fill">
          <History :height="getHeight" />

          <v-text-field
            v-model="search"
            label="Search for Song"
            prepend-inner-icon="fasldr fa-search"
            :hint="'Results: ' + files.length.toString()"
            clearable
            @update:model-value="doSearch"
            @click:clear="showAll"
          />

          <v-icon-btn
            v-tooltip:bottom="'Change Sorting Order'"
            :icon="sortOrder === 'asc'
              ? 'fasldr fa-arrow-up-wide-short'
              : 'fasldr fa-arrow-down-wide-short'
            "
            @click="changeOrder"
          />
        </div>
      </v-card-title>
      <v-card-text>
        <v-skeleton-loader
          v-if="appStore.loading"
          type="list-item-two-line, list-item-two-line, list-item-two-line"
        />
        <v-virtual-scroll
          v-else
          :items="files"
          height="calc(100vh - 250px)"
        >
          <template #default="{ item }">
            <v-card
              :key="item.title"
              density="compact"
              class="ma-1"
              color="primary"
            >
              <v-list-item lines="two">
                <v-list-item-title
                  @click="loadsong(item.url || '', (item.track ?? 0) + 1)"
                >
                  {{ item.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.album }}
                </v-list-item-subtitle>

                <template #append>
                  <v-btn
                    v-tooltip:bottom="'Download Songbook'"
                    icon="fasdr fa-file-pdf"
                    size="xs"
                    :href="item.url"
                    target="_new"
                    download
                  />
                  <!-- </div> -->
                </template>
              </v-list-item>
            </v-card>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script setup lang="ts">
import axios from "axios";
import { useRouter } from "vue-router";
import { ref, computed, onMounted, watchEffect, onBeforeMount } from "vue";
import { useAppStore } from "../stores/app";
import { useDisplay } from "vuetify";
import { type Song } from "../components/Types";
import History from "../components/History.vue";

const router = useRouter();
const { mobile } = useDisplay();

const appStore = useAppStore();

const toggleSongSearch = ref(false);
const toggleIndex = ref(false);
const toggleAlbum = ref(true);
const showAlbumTracks = ref(false);

const files = ref([] as Song[]);
const search = computed({
  get() {
    return appStore.currentSearch;
  },
  set(newVal) {
    appStore.currentSearch = newVal;
  }
})
// const url = ref("");
const sortOrder = ref<"asc" | "desc">("asc");

const sortBy = computed(() => {
  return [{ key: "name", order: sortOrder.value }];
});
const playlist = ref([] as Song[]);
const albumName = ref("");
const albumUrl = ref("");

const getHeight = computed(() => {
  return window.innerHeight;
});

const getTableHeight = computed(() => {
  return window.innerHeight - 80;
});

function titleMatch(val: string) {
  if (search.value === '' || search.value === null) {
    return false;
  } else if (val.replace(/\s+/g, '').toLowerCase().includes(search.value.replace(/\s+/g, '').toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

function changeOrder() {
  if (sortOrder.value === "asc") {
    const newfiles = [...files.value].sort((a, b) => b.title.localeCompare(a.title, 'en'))
    files.value = newfiles
    sortOrder.value = "desc"
  } else {
    const newfiles = [...files.value].sort((a, b) => a.title.localeCompare(b.title, 'en'))
    files.value = newfiles
    sortOrder.value = "asc"
  }

}

function parseTitle(book: string) {
  if (book.includes("-")) {
    return book.replace("-", " ").replace(/\B([A-Z])\B/g, " $1");
  } else {
    return book.replace(/\B([A-Z])\B/g, " $1");
  }
}

function parseTitleArtist(book: string) {
  const barray = [] as string[]
  if (book.includes("-")) {
    const [ta0 = "", ta1 = ""] = book.split("-")
    const at = ta0.replace(/\B([A-Z])\B/g, " $1");
    const bt = ta1.replace(/\B([A-Z])\B/g, " $1");
    barray.push(at, bt)
  } else {
    const lt = book.replace(/\B([A-Z])\B/g, " $1");
    barray.push(lt)
  }

  return barray
}

function showAll() {
  files.value = appStore.songs;
  search.value = '';
}

function loadbook(book: string) {
  const fname = book.replace("https://data.tdot.men/pdf/","")
  appStore.file = appStore.getServerRoot + fname;
  appStore.fileName = fname.replace(".pdf","");
  appStore.currentPage = 1;
  // toggleDrawer();
  router.push({
    path: '/viewer/'+appStore.fileName,
  });
}

function loadsong(book: string, track: number) {
  const fname = book.replace("https://data.tdot.men/pdf/","")
  appStore.file = appStore.getServerRoot + fname;
  appStore.fileName = fname.replace(".pdf","");
  appStore.currentPage = 1;
  appStore.openTrack = track;
  // toggleDrawer();
  router.push({
    path: '/viewer/'+appStore.fileName,
  });
}

function doSearch() {
  if (search.value && search.value !== "" && search.value.length > 1) {
    files.value = appStore.findSong(search.value);
    appStore.currentSearch = search.value;
  }
}



watchEffect(() => {
  if (search.value === null || search.value === "") {
    files.value = appStore.songs;
    appStore.currentSearch = "";
  }


});



onMounted(async () => {
  appStore.loading = true;
    if (appStore.fileLength === 0) {
    try {
    const data = await axios.get(appStore.getServerRoot + 'filelist.json');

    const fileitems = data.data;
    const newfiles = [...fileitems].sort((a, b) => a.name.localeCompare(b.name, 'en'))

    appStore.saveFiles(newfiles);
    } catch(err: any) {
      appStore.setAlert(err);
    }
  }
  const newSongs = [...appStore.songs].sort((a, b) => a.title.localeCompare(b.title, 'en'))

  files.value = newSongs;
  doSearch();
  appStore.loading = false;

});
</script>

<style lang="css" scoped>
.mainwindow {
  width: 60vw;
  align-self: center;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.mobilewindow {
  width: 95vw;
  align-self: center;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.trackpanel {
  align-self: center;
  width: 60vw;
  background-color: #20213d;
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}

.trackmobile {
  align-self: center;
  width: 95vw;
  background-color: #20213d;
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}
</style>
